import React, { useEffect } from "react";

const Modal = ({ children, closeModal, modalRef, showModal, modalTitle, closeOnOutsideClick, isCloseIconHide }) => {
    useEffect(() => {
        const handleCloseModal = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                closeModal();
            }
        };

        if (closeOnOutsideClick) {
            document.addEventListener("mousedown", handleCloseModal);
        }

        return () => {
            if (closeOnOutsideClick) {
                document.removeEventListener("mousedown", handleCloseModal);
            }
        };
    }, [showModal]);

    return (
        <div className="">
            <div className={`modal custom-popup-overlay ${showModal ? "show" : ""}`}>
                <div className="modal-content custom-popup-add" ref={modalRef}>
                    <div className="d-flex align-items-center justify-content-between">
                        {modalTitle && (
                            <>
                                <h2>{modalTitle}</h2>
                            </>
                        )}
                        {!isCloseIconHide && (
                            <div className="d-flex justify-content-end fs-2" style={{ cursor: "pointer" }} onClick={closeModal}>
                                &times;
                            </div>
                        )}
                    </div>
                    {!isCloseIconHide && <div className="after-line-tittle"></div>}

                    <div>{children}</div>
                </div>
            </div>
        </div>
    );
};

export default Modal;
